const initialState = {
    calculationFields: {},
    calculationFilter: {},
};

export default initialState;
